import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentModule } from './document/document.module';
import { ListCodeModule} from './list-code/list-code.module';
import { ReportModule } from './report/report.module';
import { ProfileModule } from './profile/profile.module';
import { SearchModule } from './search/search.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SaleTaxModule } from "./saletax/saletax.module";
import { BillingModule } from './billing/billing.module';
import {TaxReportModule} from "./tax-report/tax-report.module";
import {ZipFileModule} from "./zip-file/zip-file.module";
import {TaxB2PModule} from './tax-b2p/tax-b2p.module';
import {BulkTaxReportModule} from "./bulk-tax-report/bulk-tax-report.module";
import {DownloadRoutingModule} from './download/download-routing.module';
import {EmailDashboardModule} from "./email-dashboard/email-dashboard.module";
import {DocumentRequestDashboardModule} from "./document-request-dashboard/document-request-dashboard.module";
import {ResolveErrorModule} from './resolve-error/resolve-error.module';
import {HistoryLogModule} from "./history-log/history-log.module";

@NgModule({
  imports: [
    CommonModule,
    DocumentModule,
    ReportModule,
    SearchModule,
    DashboardModule,
    BillingModule,
    SaleTaxModule,
    ProfileModule,
    TaxReportModule,
    ZipFileModule,
    TaxB2PModule,
    DownloadRoutingModule,
    BulkTaxReportModule,
    ListCodeModule,
    EmailDashboardModule,
    DocumentRequestDashboardModule,
    ResolveErrorModule,
    HistoryLogModule,
  ],
  declarations: [
  ]
})
export class FeaturesModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/features.module.ts